import React from 'react';
import styled from 'styled-components';
import { useFormikContext } from 'formik';

import FormCard from '../../../../components/Cards/FormCard';
import FormikTicket from '../../Renter/Create/FormikTicket';
import { isEmpty } from 'Helpers/isEmpty';
import { paragraphReg } from '../../../../styles/Typography';

const OrderSummaryBase = ({ className, stripe, elements, setTotal, setTotalFee, discountCode }) => {
  const { values } = useFormikContext();
  const { event } = values;
  return (
    <FormCard dataTestId="reservation_summary">
      {event && !isEmpty(event) ? (
        <FormikTicket className={className} stripe={stripe} elements={elements} setTotal={setTotal} setTotalFee={setTotalFee} discountCode={discountCode} />
      ) : (
        <div className={className + '__empty-totals'}>Select an event to continue</div>
      )}
    </FormCard>
  );
};

const OrderSummary = styled(OrderSummaryBase)`
  &__empty-totals {
    ${paragraphReg}
    font-size: 16px;
    margin-top: 0;
  }
`;

export default OrderSummary;
